import React from 'react';

/**
 * RedactorSettings – checkboxes for selecting which PII types to redact.
 */

const CATEGORIES = [
  { value: 'first_name', label: 'First Name', icon: 'bi-person' },
  { value: 'last_name', label: 'Last Name', icon: 'bi-person-fill' },
  { value: 'personal_address', label: 'Personal Address', icon: 'bi-house-door' },
  { value: 'birthday', label: 'Birthday', icon: 'bi-calendar-event' },
  { value: 'full_ssn', label: 'Full SSN', icon: 'bi-shield-lock' },
  { value: 'partial_ssn', label: 'Partial SSN', icon: 'bi-shield' },
  { value: 'full_account_number', label: 'Full Account Numbers', icon: 'bi-bank' },
  { value: 'partial_account_number', label: 'Partial Account Numbers', icon: 'bi-bank2' },
  { value: 'itin', label: 'ITINs', icon: 'bi-file-earmark-lock' },
  { value: 'ptin', label: 'PTINs', icon: 'bi-file-earmark-lock2' },
  { value: 'ein', label: 'EINs', icon: 'bi-building' },
  { value: 'personal_phone', label: 'Personal Phone Numbers', icon: 'bi-telephone' },
  { value: 'personal_email', label: 'Personal Email Addresses', icon: 'bi-envelope' },
];

function RedactorSettings({ selected, setSelected, useOcr, setUseOcr, disabled }) {
  const toggle = (val) => {
    setSelected((prev) => {
      if (val === 'last_name') {
        if (prev.includes(val)) {
          return prev.filter((v) => v !== val && v !== 'middle_name');
        } else {
          const next = prev.filter((v) => v !== 'middle_name');
          return [...next, val, 'middle_name'];
        }
      }
      return prev.includes(val) ? prev.filter((v) => v !== val) : [...prev, val];
    });
  };

  const selectAll = () => setSelected([...CATEGORIES.map((c) => c.value), 'middle_name']);
  const clearAll = () => setSelected([]);

  return (
    <div className="mb-4">
      <h5 className="mb-3">
        <i className="bi bi-sliders me-2"></i>Redaction Settings
      </h5>
      <div className="d-flex gap-2 mb-3">
        <button
          className="btn btn-sm btn-outline-primary"
          onClick={selectAll}
          disabled={disabled}
        >
          Select All
        </button>
        <button
          className="btn btn-sm btn-outline-secondary"
          onClick={clearAll}
          disabled={disabled}
        >
          Clear All
        </button>
      </div>
      <div className="form-check form-switch mb-3">
        <input
          className="form-check-input"
          type="checkbox"
          role="switch"
          id="redactor-use-ocr"
          checked={useOcr}
          onChange={(event) => setUseOcr(event.target.checked)}
          disabled={disabled}
        />
        <label className="form-check-label" htmlFor="redactor-use-ocr">
          OCR scanned PDF pages
        </label>
      </div>
      <div className="row g-2">
        {CATEGORIES.map((cat) => (
          <div className="col-md-6 col-lg-4" key={cat.value}>
            <div
              className={`card h-100 ${selected.includes(cat.value) ? 'border-primary' : ''}`}
              style={{ cursor: disabled ? 'not-allowed' : 'pointer' }}
              onClick={() => !disabled && toggle(cat.value)}
            >
              <div className="card-body py-2 px-3 d-flex align-items-center">
                <div className="form-check mb-0">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    checked={selected.includes(cat.value)}
                    onChange={() => toggle(cat.value)}
                    onClick={(e) => e.stopPropagation()}
                    disabled={disabled}
                    id={`redact-${cat.value}`}
                  />
                </div>
                <i className={`bi ${cat.icon} me-2 ms-1 text-secondary`}></i>
                <label
                  className="form-check-label mb-0"
                  htmlFor={`redact-${cat.value}`}
                  style={{ cursor: 'pointer' }}
                >
                  {cat.label}
                </label>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default RedactorSettings;
